module.exports = __webpack_public_path__ + "img/books.6f8aa71e.svg";